import {actionTypes} from '../const';
const initialState = {    
   role:'',
   route:''
}
const role = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.ROLE_SUCCESS:
            return Object.assign({}, state, {
                role:action.role,
                route: action.route
            });
        default:
            return state;
    }
}
export default role